import Repository from "../Repository";

const resource = "/bo/brackets";

export default {
  /**
   * Get all brackets
   */
  get() {
    return Repository.get(`${resource}`);
  },

  /**
   * Create a bracket
   */
  create(payload) {
    return Repository.post(`${resource}`, payload);
  },

  /**
   * Get a bracket
   */
  getBracket(brackeId) {
    return Repository.get(`${resource}/${brackeId}`);
  },

  /**
   * Update a bracket
   */
  updateBracket(bracketId, payload) {
    return Repository.put(`${resource}/${bracketId}`, payload);
  },

  /**
   * Delete a bracket
   */
  deleteBracket(bracketId) {
    return Repository.delete(`${resource}/${bracketId}`);
  }
};
